import { render, staticRenderFns } from "./ConfiguracionInformeIndex.vue?vue&type=template&id=dc4dce6e"
import script from "./ConfiguracionInformeIndex.vue?vue&type=script&lang=js"
export * from "./ConfiguracionInformeIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports